// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file responses/v1/third_party_fulfillment_settings_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/third_party_fulfillment_settings_response.proto.
 */
export const file_responses_v1_third_party_fulfillment_settings_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CjxyZXNwb25zZXMvdjEvdGhpcmRfcGFydHlfZnVsZmlsbG1lbnRfc2V0dGluZ3NfcmVzcG9uc2UucHJvdG8SDHJlc3BvbnNlcy52MSKkAQolVGhpcmRQYXJ0eUZ1bGZpbGxtZW50U2V0dGluZ3NSZXNwb25zZRJOCghzZXR0aW5ncxgBIAMoCzI8LnJlc3BvbnNlcy52MS5UaGlyZFBhcnR5RnVsZmlsbG1lbnRTZXR0aW5nc1Jlc3BvbnNlLlNldHRpbmdzGisKCFNldHRpbmdzEhAKCHByb3ZpZGVyGAEgASgJEg0KBXZhbHVlGAIgASgIQpUBChBjb20ucmVzcG9uc2VzLnYxQipUaGlyZFBhcnR5RnVsZmlsbG1lbnRTZXR0aW5nc1Jlc3BvbnNlUHJvdG9QAVoELi9wYqICA1JYWKoCDFJlc3BvbnNlcy5WMcoCDFJlc3BvbnNlc1xWMeICGFJlc3BvbnNlc1xWMVxHUEJNZXRhZGF0YeoCDVJlc3BvbnNlczo6VjFiBnByb3RvMw'
    );

/**
 * @generated from message responses.v1.ThirdPartyFulfillmentSettingsResponse
 */
export type ThirdPartyFulfillmentSettingsResponse = Message<'responses.v1.ThirdPartyFulfillmentSettingsResponse'> & {
    /**
     * @generated from field: repeated responses.v1.ThirdPartyFulfillmentSettingsResponse.Settings settings = 1;
     */
    settings: ThirdPartyFulfillmentSettingsResponse_Settings[];
};

/**
 * Describes the message responses.v1.ThirdPartyFulfillmentSettingsResponse.
 * Use `create(ThirdPartyFulfillmentSettingsResponseSchema)` to create a new message.
 */
export const ThirdPartyFulfillmentSettingsResponseSchema: GenMessage<ThirdPartyFulfillmentSettingsResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_third_party_fulfillment_settings_response, 0);

/**
 * @generated from message responses.v1.ThirdPartyFulfillmentSettingsResponse.Settings
 */
export type ThirdPartyFulfillmentSettingsResponse_Settings =
    Message<'responses.v1.ThirdPartyFulfillmentSettingsResponse.Settings'> & {
        /**
         * @generated from field: string provider = 1;
         */
        provider: string;

        /**
         * @generated from field: bool value = 2;
         */
        value: boolean;
    };

/**
 * Describes the message responses.v1.ThirdPartyFulfillmentSettingsResponse.Settings.
 * Use `create(ThirdPartyFulfillmentSettingsResponse_SettingsSchema)` to create a new message.
 */
export const ThirdPartyFulfillmentSettingsResponse_SettingsSchema: GenMessage<ThirdPartyFulfillmentSettingsResponse_Settings> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_third_party_fulfillment_settings_response, 0, 0);
